module.exports = function() {
  return new Worker(__webpack_public_path__ + "7c8149d74f01e981b7fc.worker.js");
};